module.exports = __webpack_public_path__ + "img/developer-3.f231072d.svg";